var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYclients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FFDD2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M12.5 10h5.4l2.1 9.2L22.1 10h5.4L21.6 22.8V30h-5.2v-7.2L12.5 10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYclients);
export default __webpack_public_path__ + "static/media/yclients.d58b7c8fbba6101a1db255e1a71b1992.svg";
export { ForwardRef as ReactComponent };